var map = {
	"./close-icon.png": 132,
	"./trash-icon.png": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared ^\.\/.*$
// module id = 144
// module chunks = 0